<template>
  <div class="p-3">
    <div class="mod-header">
      <div class="mod-header--title">{{title}}</div>
    </div>
    <div class="h-100 d-flex flex-column" style="background: #fff">
      <div class="filter-bar pt-3" style="font-size: 0.85rem">
        <div class="tab-style text-muted">
          <a href="javascript:void(0)" v-for="f in filters" :key="f" @click="setFilter(f)" class="tab-style-item font-weight-bold" :class="{ active: !filter || filter == f }">{{f}}</a>
        </div>
      </div>
      <!-- style="height: calc(100% - 30px - 1rem)"> -->
      <div v-for="(f,i) in panels" :key="f" v-show="filter == f || singleSlot" class="h-100 d-flex flex-column">
        <slot :name="`body_${i}`"></slot>
      </div>
    </div>
    <slot name="footer"></slot>
  </div>
</template>
<script>
export default {
  components: {},
  props: ['filters', 'title', 'singleSlot'],
  created() {},
  async mounted() {},
  data() {
    return {
      filter: this.filters[0],
    }
  },
  computed: {
    panels() {
      return this.singleSlot ? [this.filters[0]] : this.filters
    },
  },
  methods: {
    setFilter(f) {
      this.filter = f
      this.$emit('filter', f)
    },
  },
}
</script>
<style scoped lang="scss">
.mod-header {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  padding: 10px;
  background: var(--border-color);
  position: relative;
  box-sizing: border-box;
  display: flex;
}

.mod-header--img {
  border-radius: 50%;
  align-self: center;
  padding: 10px;
  box-sizing: border-box;
  width: 54px;
  height: 54px;
}

.mod-header--title {
  align-self: center;
  padding: 10px;
  flex: 1;
  user-select: none;
  font-size: 1rem;
  font-weight: bold;
  text-align: left;
}

.mod-header--title.enabled {
  cursor: pointer;
  border-radius: 5px;
}

.mod-header--title.enabled:hover {
  box-shadow: 0px 2px 5px rgba(0.2, 0.2, 0.5, 0.1);
}

.mod-header--close-button {
  width: 40px;
  align-self: center;
  height: 40px;
  margin-right: 10px;
  box-sizing: border-box;
  cursor: pointer;
  border-radius: 5px;
  margin-left: auto;
}

.mod-header--close-button:hover {
  box-shadow: 0px 2px 5px rgba(0.2, 0.2, 0.5, 0.1);
}

.mod-header--close-button img {
  width: 100%;
  height: 100%;
  padding: 13px;
  box-sizing: border-box;
}

.mod-header--svg-button {
  margin: 0 auto;
  display: block;
  fill: white;
}

.clickable {
  cursor: pointer;
}

@media (max-width: 450px) {
  .mod-header {
    border-radius: 0px;
  }
}
</style>
